const buildModerators = (userProfile, staff = []) =>
  staff
    .filter(st => st.pairedAt || st.type === 'physician')
    .sort((a, b) => a.user.fullNameWithTitle.localeCompare(b.user.fullNameWithTitle))
    .reduce(
      (acc, cur) => ({
        options: [...acc.options, cur.user.id],
        labels: [...acc.labels, cur.user.fullNameWithTitle],
      }),
      {
        options: [userProfile.id],
        labels: [userProfile.attributes.fullNameWithTitle],
      },
    );

export default buildModerators;
